import { SolutionCard } from 'components/SolutionCard/SolutionCard';
import './styles.scss';
import GradientText from 'components/GradientText';
import { useSelector } from 'react-redux';
import { selectHomepage } from 'store/slices/HomepageSlice';

const Solutions = () => {
    const { banner_cards = [], banner_title } = useSelector(selectHomepage);

    return (
        <section id="information-wrapper" className="container">
            <div className="solutions">
                <GradientText size="super-small" textColor="white">
                    <span dangerouslySetInnerHTML={{ __html: banner_title }} />
                </GradientText>
                <div>
                    {banner_cards.map(item => (
                        <SolutionCard key={item.title} image={item.icon} numbers={item.title} description={item.text} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Solutions;
